import React, { useState } from 'react';
import axios from 'axios';
import './LoginForm.css'; // Create this CSS file
import { useUser } from '../../context/UserContext';

const LoginForm = ({ onLoginSuccess }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { setUser } = useUser();


  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setError(''); // Clear error when user types
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {

      const response = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login`, formData);

      // Store token (consider using httpOnly cookies in production)
      localStorage.setItem('token', response.data.token);
      setUser(response.data.user);
      // Call success callback
      if (onLoginSuccess) {
        
        localStorage.setItem('userData', JSON.stringify(response.data.user));
        onLoginSuccess(response.data.user);
      }

    } catch (err) {
      setError(err.response?.data?.error || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Business Login</h2>
        <p className="subtitle">Access your business dashboard</p>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@business.com"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="••••••••"
              required
              disabled={loading}
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button
            type="submit"
            className="login-button"
            disabled={loading}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>

          <div className="links">
            <a href="/forgot-password" className="link">Forgot password?</a>
            <a href="/register" className="link">Create account</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginForm;